/* src/app/action-report/action-report.component.scss */
.mat-cell {
  text-align: left;
}
.footer-cell {
  flex: 1;
  flex-grow: 1;
  text-align: left;
}
.mat-row {
  border-color: #605959;
}
a:hover {
  cursor: pointer;
}
a:not([href]):not([tabeindex]) {
  text-decoration: underline;
}
.table-container {
  background-color: #3E3F48 !important;
  border-radius: 20px;
  width: 100%;
  margin-top: 30px;
  padding: 0 40px 10px 40px;
}
.table-container ::ng-deep .mat-mdc-table {
  background: transparent !important;
}
.table-container ::ng-deep .mat-mdc-row:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}
.table-container .mat-mdc-cell,
.table-container ::ng-deep .mat-mdc-cell {
  color: white;
}
.table-container .mat-mdc-cell a,
.table-container ::ng-deep .mat-mdc-cell a {
  text-decoration: none;
}
.table-container .mat-mdc-cell a span,
.table-container ::ng-deep .mat-mdc-cell a span {
  text-decoration: none;
}
.table-container .mat-mdc-header-cell,
.table-container ::ng-deep .mat-mdc-header-cell {
  color: white;
}
#avgTable .mat-row .mat-cell:nth-child(2) {
  font-family: "monospace";
}
.tip {
  margin: 20px;
  display: block;
  text-align: left;
  background: #fffec8;
  color: black;
  padding: 20px;
  border-radius: 5px;
  position: relative;
}
.tip a {
  color: black;
}
.summary {
  display: flex;
  text-align: center;
  justify-content: center;
  gap: 20px;
  position: relative;
}
.summary app-back-button {
  position: absolute;
  top: 40px;
  left: 20px;
}
.summary .info .stat {
  color: #80dec4;
  margin-top: 40px;
  margin-bottom: 20px;
  font-size: 3rem;
  line-height: 1.19;
}
.summary .info .stat img {
  width: 40px;
}
h2 {
  text-align: right;
  padding-right: 20px;
  margin-top: -20px;
}
h2.client-name-super {
  position: fixed;
  top: 70px;
  right: 0;
  margin-top: 0;
}
.type-selector {
  padding: 6px;
  border-radius: 20px;
  margin-left: 10px;
}
.mat-column-rn {
  max-width: 100px;
}
.mat-column-kind {
  max-width: 150px;
}
/*# sourceMappingURL=action-report.component.css.map */
